var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.821 0H3.18173C1.42124 0 0 1.48929 0 3.33118V36.6702C0 38.5078 1.42124 40 3.18173 40H36.821C38.5705 40 40 38.5078 40 36.6702V3.33118C40 1.48929 38.5705 0 36.821 0ZM26.8874 11.8756C26.0598 11.3682 25.4046 10.9682 24.5811 10.9682C23.774 10.9682 23.0819 11.179 22.729 11.5359C22.3788 11.8885 22.2023 12.5722 22.2023 13.5827V15.0749H26.5167L25.5837 19.2303H22.2009V33.0381H16.7827V19.2303H14.2521V15.0749H16.7827V13.4881C16.7827 11.8197 16.9728 10.8206 17.349 9.99355C17.7252 9.17222 18.4556 8.25772 19.4679 7.74027C20.4774 7.22282 21.9739 6.96194 23.5237 6.96194C25.1105 6.96194 26.3498 7.51666 27.8709 7.96388L26.8874 11.8756Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookFooter);
export default __webpack_public_path__ + "static/media/facebook-footer.f6fdf3a2af2025eb715015fc7575992f.svg";
export { ForwardRef as ReactComponent };